import '@hotwired/turbo-rails'
import './controllers'
import React from 'react'
import { createRoot } from 'react-dom/client'
import ProjectActions from './components/ProjectActions'
import ProjectActionsDisabled from './components/ProjectActionsDisabled'
import Breadcrumbs from './components/Breadcrumbs'
import ProjectSettings from './components/ProjectSettings'
import ProjectEmpty from './components/ProjectEmpty'
import ProjectContainer from './components/ProjectContainer'
import ProjectsContainer from './components/ProjectsContainer'
import ProjectsHeader from './components/ProjectsHeader'
import ApplicationHeader from './components/ApplicationHeader'
import Dashboard from './components/Dashboard'
import NewProjectSetup from './components/NewProjectSetup'
import ContentForm from './components/ContentForm'
import ContentPdfForm from './components/ContentPdfForm'
import ContentImagesForm from './components/ContentImagesForm'
import ContentAudioForm from './components/ContentAudioForm'
import ContentActions from './components/ContentActions'
import AnalysisDashboard from './components/AnalysisDashboard'
import ProjectCredentials from './components/ProjectCredentials'
import DeleteProject from './components/DeleteProject'
import ProjectAgentsSettings from './components/ProjectAgentsSettings'
import ProgressUsage from './components/ProgressUsage'
import UserStats from './components/UserStats'
import PublicProject from './components/PublicProject'
const components = {
  ProjectActions,
  ProjectActionsDisabled,
  ProjectsHeader,
  Breadcrumbs,
  ProjectSettings,
  ProjectEmpty,
  ProjectContainer,
  ProjectsContainer,
  ApplicationHeader,
  Dashboard,
  NewProjectSetup,
  ContentForm,
  ContentPdfForm,
  ContentImagesForm,
  ContentAudioForm,
  ContentActions,
  AnalysisDashboard,
  ProjectCredentials,
  DeleteProject,
  ProjectAgentsSettings,
  ProgressUsage,
  UserStats,
  PublicProject,
}

document.addEventListener('turbo:load', mountComponents)
document.addEventListener('turbo:render', mountComponents)

function mountComponents () {
  document.querySelectorAll('[data-react-component]').forEach(element => {
    if (element.dataset.reactMounted) return

    const componentName = element.dataset.reactComponent
    const props = JSON.parse(element.dataset.reactProps)
    const Component = components[componentName]

    if (Component) {
      const root = createRoot(element)
      root.render(<Component {...props} />)
      element.dataset.reactMounted = 'true'
    }
  })
}